function addProductAndGoToCart(e) {
  const { id, quantity, freeGift } = e.dataset;
  let items = [{ id, quantity: Number(quantity) }];

  if (freeGift && Number(quantity) === 6) {
    let properties = { _includeFreeGift: freeGift };
    items.map((item) => {
      item.properties = properties;

      return item
    })

    items.push({ id: freeGift, quantity: 1, properties: { _isFreeGift: true } });
  }

  e.disabled = true;
  e.innerText = 'Adding...';
  
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items }),
  })
    .then(() => {
      window.dataLayer = window.dataLayer || [];
      window.redirectToCart = true;
      window._conv_q = window._conv_q || [];
      window._conv_q.push(["executeExperiment", "100458631"]);

      e.innerText = 'Added to cart';
    })
    .catch((error) => {
      console.error("Error:", error);
    }).finally(() => {
      setTimeout(() => {
        e.disabled = false;
        window.location.href = '/cart';
      }, 1000);
    });
}

function addProductAndGoToCheckout(e) {
  const { id, quantity, sellingPlan } = e.dataset;
  
  let items = [{ 
    id, 
    quantity: Number(quantity), 
    selling_plan: sellingPlan 
  }];

  e.disabled = true;
  e.innerText = 'Adding...';
  
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items }),
  })
    .then(() => {
      window.dataLayer = window.dataLayer || [];
      window.redirectToCart = true;
      window._conv_q = window._conv_q || [];
      window._conv_q.push(["executeExperiment", "100458631"]);

      e.innerText = 'Added to cart';
    })
    .catch((error) => {
      console.error("Error:", error);
    }).finally(() => {
      setTimeout(() => {
        e.disabled = false;
        window.location.href = '/checkout';
      }, 1000);
    });
}
